"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomBlockMeta = void 0;
const resource_model_1 = require("./resource.model");
const customSectionMeta_model_1 = require("./customSectionMeta.model");
class CustomBlockMeta extends resource_model_1.Resource {
    load(x, languages) {
        super.load(x, languages);
        this.sectionsLegend = this.cleanArray(x.sectionsLegend, String);
        this.sections = {};
        this.sectionsLegend.forEach(s => (this.sections[s] = new customSectionMeta_model_1.CustomSectionMeta(x.sections[s], languages)));
    }
    validate(languages) {
        const e = super.validate();
        this.sectionsLegend.forEach(s => this.sections[s].validate(languages).forEach(es => e.push(`${s}.${es}`)));
        return e;
    }
    /**
     * Set the default values of the specified sections.
     */
    setSectionsDefaultValues() {
        const sections = {};
        this.sectionsLegend.forEach(s => (sections[s] = this.sections[s].setFieldsDefaultValues()));
        return sections;
    }
    /**
     * Load the values of the specified sections.
     * @param sections the sections target of the load action
     * @param newSections the values to set in the sections
     */
    loadSections(newSections) {
        const sections = {};
        newSections = newSections || {};
        this.sectionsLegend.forEach(s => (sections[s] = this.sections[s].loadFields(newSections[s])));
        return sections;
    }
    /**
     * Validate the sections and return an array with errors, if any.
     */
    validateSections(sections) {
        sections = sections || {};
        const e = new Array();
        this.sectionsLegend.forEach(s => this.sections[s].validateFields(sections[s]).forEach(ef => e.push(`${s}.${ef}`)));
        return e;
    }
}
exports.CustomBlockMeta = CustomBlockMeta;
